import Deselect from './Deselect';

export default Deselect;